var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReviewDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 288,
    height: 162,
    viewBox: "0 0 288 162",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1303_3191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M266 141H22C22.2391 74.1328 76.7688 20 144 20C211.231 20 265.761 74.1328 266 141Z",
    fill: "#333843"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192.386,
    y: 123.294,
    width: 25.078,
    height: 21.3623,
    rx: 2,
    fill: "#DEDEE3",
    stroke: "#06080A",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174.979,
    y: 143.318,
    width: 60.621,
    height: 7.68185,
    rx: 2,
    fill: "#DEDEE3",
    stroke: "#06080A",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192.48,
    y: 124.224,
    width: 24.8941,
    height: 2.93188,
    fill: "#06080A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137,
    y: 37,
    width: 136,
    height: 86.9023,
    rx: 3,
    fill: "#B4B4BB",
    stroke: "#06080A",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137 113.893H273V120.89C273 122.547 271.657 123.89 270 123.89H140C138.343 123.89 137 122.547 137 120.89V113.893Z",
    fill: "#DEDEE3",
    stroke: "#06080A",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.008 78.2583L130.419 80.4614L144.08 89.7243L146.303 87.1763C145.986 84.9468 143.778 83.037 139.335 80.4613C134.892 77.8857 132.922 77.8546 132.008 78.2583Z",
    fill: "#06080A",
    stroke: "#06080A",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.105 66.1454C134.442 66.2351 133.957 66.8817 134.238 67.5241L135.255 74.3719C135.457 75.4487 135.171 76.5083 134.526 77.3688L131.773 81.0397C130.146 83.6864 130.105 87.9594 133.079 90.2804C136.066 92.6995 140.007 91.7258 142.234 88.7575L150.061 78.3201C150.588 77.6175 150.74 76.7679 150.081 76.1836C149.312 75.524 148.381 75.8745 147.816 76.6281L149.015 75.0293C149.542 74.3267 149.489 73.2743 148.83 72.69C148.061 72.0304 146.851 72.2022 146.286 72.9557L147.28 71.609C147.887 70.7995 147.633 69.6755 146.783 69.1228C145.999 68.7066 145.017 68.8914 144.495 69.5978L143.848 70.4608L148.795 63.8648C149.402 63.0553 149.148 61.9313 148.298 61.3787C147.514 60.9624 146.532 61.1472 146.011 61.8537L138.687 71.6191L138.195 68.4589C137.939 66.9986 136.593 65.9841 135.123 66.1429L135.115 66.1531L135.105 66.1454Z",
    fill: "#E8CBB7",
    stroke: "#06080A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.138 72.1383C137.891 71.8055 137.96 71.3352 138.292 71.0877C138.623 70.8402 139.093 70.9093 139.34 71.242L138.138 72.1383ZM139.776 80.5679L139.326 81.1679L138.128 80.265L138.578 79.665L139.776 80.5679ZM138.739 71.6902C139.34 71.242 139.34 71.2423 139.34 71.2426C139.34 71.2427 139.341 71.243 139.341 71.2432C139.341 71.2437 139.341 71.2442 139.342 71.2448C139.343 71.246 139.344 71.2475 139.345 71.2493C139.348 71.2528 139.351 71.2575 139.355 71.2632C139.364 71.2747 139.375 71.2905 139.389 71.3105C139.417 71.3506 139.456 71.4075 139.504 71.48C139.599 71.6248 139.728 71.8328 139.873 72.0936C140.162 72.6132 140.516 73.353 140.773 74.2296C141.288 75.9829 141.43 78.3624 139.776 80.5679L138.578 79.665C139.848 77.971 139.771 76.1373 139.336 74.6524C139.118 73.9099 138.815 73.2743 138.564 72.8233C138.44 72.5987 138.329 72.4225 138.252 72.3046C138.213 72.2457 138.183 72.2016 138.163 72.1734C138.153 72.1593 138.146 72.1492 138.142 72.1433C138.14 72.1404 138.138 72.1385 138.138 72.1376C138.137 72.1372 138.137 72.137 138.137 72.1372C138.137 72.1372 138.138 72.1373 138.138 72.1375C138.138 72.1376 138.138 72.1378 138.138 72.1379C138.138 72.1381 138.138 72.1383 138.739 71.6902Z",
    fill: "#06080A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.704 69.6792L140.946 73.6074C140.299 74.284 140.298 75.3808 140.95 76.0585C141.599 76.7343 142.651 76.7336 143.298 76.057L147.056 72.1288C147.703 71.4522 147.704 70.3554 147.052 69.6777C146.402 69.0019 145.35 69.0026 144.704 69.6792Z",
    fill: "#E8CBB7",
    stroke: "#06080A",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.615 72.7131L143.187 76.2978C142.54 76.9744 142.539 78.0712 143.191 78.7489C143.84 79.4247 144.892 79.424 145.539 78.7474L148.968 75.1626C149.614 74.486 149.615 73.3892 148.963 72.7115C148.314 72.0358 147.262 72.0364 146.615 72.7131V72.7131Z",
    fill: "#E8CBB7",
    stroke: "#06080A",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.149 76.2557L145.677 78.8404C145.03 79.517 145.029 80.6138 145.681 81.2915C146.331 81.9673 147.383 81.9666 148.029 81.29L150.501 78.7053C151.148 78.0287 151.149 76.9319 150.497 76.2542C149.848 75.5785 148.796 75.5791 148.149 76.2557V76.2557Z",
    fill: "#E8CBB7",
    stroke: "#06080A",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.3777 100.235L110.313 107.253C118.442 111.663 128.565 109.58 134.292 102.318L145.983 87.4946L131.688 78.5765L120.886 93.2277L106.652 84.1033C103.26 81.929 99.4541 80.4766 95.4647 79.9121C91.0816 79.2918 85.5589 78.5765 83.3997 78.5765",
    fill: "#FFBB45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.3777 100.235L110.313 107.253C118.442 111.663 128.565 109.58 134.292 102.318L145.983 87.4946L131.688 78.5765L120.886 93.2277L106.652 84.1033C103.26 81.929 99.4541 80.4766 95.4647 79.9121C91.0816 79.2918 85.5589 78.5765 83.3997 78.5765",
    stroke: "#06080A",
    strokeWidth: 1.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.601 93.4642C121.732 93.0711 121.519 92.6465 121.126 92.5158C120.733 92.3852 120.309 92.5979 120.178 92.9909L121.601 93.4642ZM120.89 93.2275C120.178 92.9909 120.178 92.9911 120.178 92.9913C120.178 92.9914 120.178 92.9916 120.178 92.9917C120.177 92.992 120.177 92.9923 120.177 92.9927C120.177 92.9934 120.177 92.9942 120.176 92.9951C120.176 92.997 120.175 92.9993 120.174 93.0021C120.172 93.0077 120.17 93.0152 120.167 93.0245C120.161 93.0431 120.153 93.0691 120.143 93.1023C120.124 93.1687 120.096 93.264 120.064 93.387C120 93.633 119.917 93.9898 119.834 94.4473C119.668 95.3623 119.504 96.6813 119.504 98.3236H121.004C121.004 96.7808 121.158 95.5518 121.31 94.715C121.386 94.2967 121.461 93.9766 121.516 93.7648C121.544 93.6588 121.566 93.58 121.581 93.5295C121.589 93.5042 121.594 93.486 121.598 93.4751C121.599 93.4696 121.601 93.466 121.601 93.4641C121.602 93.4632 121.602 93.4628 121.602 93.4628C121.602 93.4628 121.602 93.4629 121.602 93.4631C121.602 93.4632 121.601 93.4634 121.601 93.4636C121.601 93.4636 121.601 93.4638 121.601 93.4638C121.601 93.464 121.601 93.4642 120.89 93.2275Z",
    fill: "#06080A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.901 150.813C108.847 150.813 109.349 149.991 109.159 149.112C107.081 136.493 103.116 114.714 103.116 114.714L105.696 107.14C106.643 104.299 106.579 101.145 105.442 98.368L102.608 91.3674C100.594 85.1183 95.4348 80.4873 88.5093 80.4873H72.8412C64.8483 80.4873 58.8059 86.6344 58.0498 94.4568C56.6647 109.159 55.2161 128.734 51.1879 149.112C50.9973 149.997 51.5056 150.813 52.4459 150.813H107.888H107.901Z",
    fill: "#FFBB45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.0624 91.2972C56.5503 107.261 55.1078 129.492 51.2003 149.615C51.0097 150.501 51.518 151.38 52.4584 151.38H107.9C108.847 151.38 109.349 150.494 109.158 149.615L103.116 114.382L104.311 111.293C106.579 105.49 106.198 98.9286 103.243 93.3739",
    stroke: "#06080A",
    strokeWidth: 1.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.752 141.64L93.0938 141.468L93.1634 124.441L94.4342 124.441C96.2743 125.895 97.4341 128.587 97.0834 133.721C96.7328 138.854 95.5966 141.105 94.752 141.64Z",
    fill: "#06080A",
    stroke: "#06080A",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.723 138.651C114.701 138.473 115.354 137.545 115.18 136.579C115.053 135.876 114.519 135.348 113.863 135.183C114.694 135.051 115.502 134.914 116.246 134.779C117.225 134.602 117.877 133.674 117.703 132.708C117.529 131.742 116.593 131.102 115.615 131.279L115.496 131.301C116.121 131.168 116.717 131.035 117.255 130.905C118.223 130.672 118.815 129.692 118.587 128.751C118.357 127.795 117.386 127.213 116.415 127.446C114.376 127.937 108.713 128.855 106.207 129.296C106.207 129.296 112.284 126.716 114.327 125.963C115.262 125.618 115.742 124.591 115.392 123.672C115.049 122.753 114.013 122.287 113.081 122.631C110.936 123.428 108.765 124.348 107.017 125.092C106.13 125.469 105.168 125.879 104.451 126.162C103.947 126.088 103.432 126.063 102.898 126.106L102.185 126.162C103.671 124.844 104.696 123.82 104.77 123.743C105.466 123.039 105.635 121.96 105.264 121.094C105.039 120.45 104.26 119.69 103.732 119.758C103.344 119.807 102.499 120.958 102.204 121.256C102.174 121.29 99.1237 124.348 95.9269 126.614C94.2347 126.638 92.9894 126.611 91.7464 126.524C87.1284 126.198 83.3117 130.044 84.1335 134.601V134.601C84.5995 137.186 86.5186 139.223 89.138 139.404C96.6165 139.922 109.727 139.381 113.718 138.658L113.717 138.655L113.723 138.651Z",
    fill: "#D6AA8A",
    stroke: "#06080A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.585 131.283L107.026 132.555Z",
    fill: "#D6AA8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.585 131.283L107.026 132.555",
    stroke: "#06080A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.812 135.189L106.153 135.77Z",
    fill: "#D6AA8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.812 135.189L106.153 135.77",
    stroke: "#06080A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.4302 100.235L64.5709 123.167L94.4331 124.441V141.64L62.178 140.234C52.0852 139.794 44.6008 130.702 46.1088 120.713L48.6733 103.725C50.7183 90.1781 61.9666 79.7382 75.6584 79.2593C76.4964 79.23 77.1617 79.2135 77.5961 79.2135",
    fill: "#FFBB45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.4302 100.235L64.5709 123.167L94.4331 124.441V141.64L62.178 140.234C52.0852 139.794 44.6008 130.702 46.1088 120.713L48.6733 103.725C50.7183 90.1781 61.9666 79.7382 75.6584 79.2593C76.4964 79.23 77.1617 79.2135 77.5961 79.2135",
    stroke: "#06080A",
    strokeWidth: 1.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.3608 85.9066L80.5441 88.9906C80.8334 89.0583 81.1344 89.0575 81.4234 88.9884L93.7403 86.0416C98.1185 84.9941 98.3768 78.846 94.102 77.4331L80.2313 72.8486C80.0987 72.8048 79.9555 72.8057 79.8235 72.8514L66.9196 77.3124C62.6833 78.777 62.9969 84.8857 67.3608 85.9066Z",
    fill: "#FFBB45",
    stroke: "#06080A",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.5002 80.1378C67.5859 80.1378 66.6292 82.6966 73.9665 84.2959",
    stroke: "#06080A",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.1506 80.1378C94.065 80.1378 95.0217 82.6966 87.6844 84.2959",
    stroke: "#06080A",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0916 81.7269V73.5012C89.0916 73.5012 100.492 75.9067 100.631 65.5832C100.69 61.1593 100.462 57.0961 99.0192 52.3645C97.252 46.5674 94.3565 42.0211 85.5342 42.0211C78.843 42.0476 73.3663 47.5435 73.3663 54.2373V81.7269C73.3663 86.068 76.8872 89.5886 81.2289 89.5886C85.5706 89.5886 89.0916 86.068 89.0916 81.7269V81.7269Z",
    fill: "#E8CBB7",
    stroke: "#06080A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0911 73.5045C89.0911 73.5045 85.3285 72.9353 81.9697 71.6383C81.6785 71.5258 81.4667 71.9195 81.7182 72.1015L89.0911 77.4353V73.5011",
    fill: "#06080A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0911 73.5045C89.0911 73.5045 85.3285 72.9353 81.9697 71.6383C81.6785 71.5258 81.4667 71.9195 81.7182 72.1015L89.0911 77.4353V73.5011",
    stroke: "#06080A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.9988 58.4657C87.637 58.4657 87.3436 58.1042 87.3436 57.6583C87.3436 57.2124 87.637 56.851 87.9988 56.851C88.3607 56.851 88.6541 57.2124 88.6541 57.6583C88.6541 58.1042 88.3607 58.4657 87.9988 58.4657Z",
    fill: "#06080A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.5606 56.8044C95.1987 56.8044 94.9054 56.4429 94.9054 55.997C94.9054 55.5512 95.1987 55.1897 95.5606 55.1897C95.9225 55.1897 96.2158 55.5512 96.2158 55.997C96.2158 56.4429 95.9225 56.8044 95.5606 56.8044Z",
    fill: "#06080A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.8616 54.1245C91.7054 55.9311 92.3209 57.7212 94.8988 59.4881C95.4514 59.8686 95.2032 60.7752 94.5977 61.0631L93.3501 61.6521",
    stroke: "#06080A",
    strokeWidth: 1.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.7449 64.9536C92.7449 64.9536 91.1565 65.2721 89.8857 64.9536",
    stroke: "#06080A",
    strokeWidth: 1.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5426 60.8128L77.178 57.946L78.1311 56.035L80.6725 57.946C82.7161 56.0769 85.4086 53.0468 85.005 50.2924L83.7342 45.8333C83.7342 45.8333 88.157 49.2404 88.4997 49.3365C88.8425 49.4326 90.7235 49.3365 90.7235 49.3365C90.7235 49.3365 91.0654 46.0891 91.3586 46.1517C91.9273 46.2729 93.2647 48.768 93.2647 48.768C95.9626 49.1521 98.1305 48.4443 98.6653 48.0104C98.6653 48.0104 95.9587 41.6934 89.9567 38.8268C86.4622 37.1578 72.9418 33.74 67.012 43.6139C65.6792 45.8333 64.1555 50.9394 63.8354 53.1689C63.0501 58.6389 62.6619 66.7123 63.8352 76.4196L70.0741 78.002L71.3448 74.4985L72.9418 78.002L81.3078 74.4985C78.7773 71.4617 77.8133 67.8199 77.307 66.4535C76.7511 64.9533 76.5426 62.4053 76.5426 60.8128Z",
    fill: "#232B37",
    stroke: "#06080A",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5396 61.3329C74.3925 59.1921 74.1741 57.3259 74.419 56.2704C74.5812 55.5656 75.1371 55.0065 75.8387 54.8278C76.6924 54.6127 77.6488 54.8377 78.3702 55.4267C80.0149 56.7667 80.4749 58.6031 80.4749 58.6031",
    fill: "#E8CBB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5396 61.3329C74.3925 59.1921 74.1741 57.3259 74.419 56.2704C74.5812 55.5656 75.1371 55.0065 75.8387 54.8278C76.6924 54.6127 77.6488 54.8377 78.3702 55.4267C80.0149 56.7667 80.4749 58.6031 80.4749 58.6031",
    stroke: "#06080A",
    strokeWidth: 1.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5907 65.272C76.2907 65.272 75.8681 64.6161 75.9095 63.7237C76.0057 61.6502 79.1757 61.6502 79.2719 63.7237C79.3133 64.6161 78.8906 65.272 77.5907 65.272Z",
    fill: "#FFBB45",
    stroke: "#06080A",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.536 57.6097C202.076 54.9431 205.925 54.9431 207.464 57.6097L226.939 91.3414C228.479 94.0081 226.554 97.3414 223.475 97.3414H184.525C181.446 97.3414 179.521 94.0081 181.061 91.3414L200.536 57.6097Z",
    fill: "#FF7A7A",
    stroke: "#06080A",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.058 84.1208L206.942 84.1208L206.942 67.4486L201.058 67.4486L201.058 84.1208Z",
    fill: "#F3F3F7",
    stroke: "#06080A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204 87.2042C202.375 87.2042 201.058 88.5214 201.058 90.1463C201.058 91.7712 202.375 93.0885 204 93.0885C205.625 93.0885 206.942 91.7712 206.942 90.1463C206.942 88.5214 205.625 87.2042 204 87.2042Z",
    fill: "#F3F3F7",
    stroke: "#06080A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1303_3191"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 288,
    height: 162,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewDark);
export default __webpack_public_path__ + "static/media/review-dark.be6e2af59909c89f274c0a4170acf2dd.svg";
export { ForwardRef as ReactComponent };